"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _react2 = require("@emotion/react");
var _Text = _interopRequireDefault(require("../../../core/Text"));
var _useIsMobile = require("../../../hooks/useIsMobile");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const AppPicker = ({
  selected,
  small,
  icon,
  label,
  lightTheme,
  className = 'app-picker',
  href
}) => {
  const theme = (0, _react2.useTheme)();
  const isMobile = (0, _useIsMobile.useIsMobile)();
  const fontSize = isMobile ? selected ? '14px' : '12px' : '11px';

  // TODO: handle text color based on side menu

  return selected || !small ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Wrapper, {
    isLightTheme: lightTheme,
    className: className,
    nostyle: true,
    small: small,
    theme: theme,
    selected: selected,
    href: href,
    selectedcolor: lightTheme ? theme.lightAppPickerActiveBackground : '#ffffff',
    deselectedcolor: lightTheme ? theme.lightAppPickerBackground : 'rgba(255, 255, 255, 0.16)',
    title: label,
    trackingName: "Sidemenu",
    trackingEvent: 'Menu click: ' + label,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.IconWrapper, {
      className: selected ? 'selected' : '',
      isLightTheme: lightTheme,
      theme: theme,
      small: small,
      children: icon
    }), !selected && !isMobile ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.AbsoluteText, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
        semibold: true,
        color: !lightTheme && !selected ? 'white' : theme.lightAppPickerTextColor,
        size: fontSize,
        children: label
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      semibold: true,
      color: !lightTheme && !selected ? 'white' : !lightTheme && small ? theme.lightAppPickerActiveTextColor : small ? theme.lightMenuItemTextColor : 'black',
      size: fontSize,
      whiteSpace: small ? 'nowrap' : undefined,
      children: label
    })]
  }) : null;
};
var _default = exports.default = AppPicker;